import React from 'react';
import { useI18n } from '../contexts/I18nContext';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from './ui/dialog';
import { Loader2 } from 'lucide-react';

export function EditMblDialog({ editMblDialog, editingMbl, onChange, onCancel, onConfirm }) {
  const { t } = useI18n();
  return (
    <Dialog open={editMblDialog.open} onOpenChange={(o) => !editingMbl && onCancel(!o)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('shipments.editMblTitle')}</DialogTitle>
          <DialogDescription>{t('shipments.editMblDesc')}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div>
            <Label>{t('shipments.currentMbl')}</Label>
            <Input value={editMblDialog.mbl || ''} disabled className="mt-1 font-mono" />
          </div>
          <div>
            <Label>{t('shipments.newMblLabel')}</Label>
            <Input
              value={editMblDialog.newMbl}
              onChange={(e) => onChange(e.target.value.toUpperCase())}
              className="mt-1 font-mono"
              placeholder={t('shipments.newMblPlaceholder')}
              data-testid="new-mbl-input"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onCancel(false)} disabled={editingMbl}>
            {t('common.cancel')}
          </Button>
          <Button onClick={onConfirm} disabled={editingMbl || !editMblDialog.newMbl} data-testid="confirm-edit-mbl">
            {editingMbl ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
            {t('common.save')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
